import React from 'react';
import './ITSoftware.css';

function ITSoftware() {
  return (
    <div className="service-page">
      {/* Hero Section */}
      <section
        className="hero-image-section"
        style={{ backgroundImage: "url('/images/it_software_hero.png')" }}
      >
        <div className="hero-text-container">
          <h1>IT & Software</h1>
          <p>Enabling tech innovation through expert financial, legal, and strategic advisory</p>
        </div>
      </section>

      {/* Content Section */}
      <section className="service-content">
        <div className="content-left">
          <h2>We don’t just build software—we build digital resilience</h2>
          <p>We provide tailored services for software firms, SaaS platforms, ITES, and startups innovating in digital technologies.</p>
          <p>Our team supports R&D credits, product monetization strategies, global contracts, and data compliance frameworks.</p>
          <p>Navigate transfer pricing, IP protection, export benefits, and secure investor readiness with our technology industry expertise.</p>
        </div>
        <div className="content-right">
          <img src="/images/it_software.jpg" alt="IT & Software" />
        </div>
      </section>
    </div>
  );
}

export default ITSoftware;
